import React from 'react';
import { Tooltip, Position, Icon, Card,NonIdealState,Spinner } from '@blueprintjs/core';
import ThemeWrapper from '../components/styles/ThemeWrapper/index.js';
import ErrorBoundary from '../components/errors/ErrorBoundary';
import Flexbox from 'flexbox-react';
import { Provider } from 'mobx-react';
import axios from 'axios';
import Cookies from 'js-cookie';
import EmptyStateNotice from '../components/goal_performance/EmptyStateNotice.js';
import UserBrief360SummaryReport from '../components/feedback_360_reports/UserBrief360SummaryReport.js';
import UserFormBrief360Report from '../components/feedback_360_reports/UserFormBrief360Report.js';
import Utilities from "../utils/Utilities.js";
import '../components/feedback_360_reports/Review360ReportUser.css';
import ScrollableDropdown from '../components/shared/ScrollableDropdown.jsx';
import CurrentUserStore from "../stores/CurrentUserStore.js";
export default class Review360ReportUserView extends React.Component {

  state = {
    isLoading: false,
    isDirectAccess: false,
    isInitializing: true,
    goalCycleList: [],
    selectedTimeframe: {},
    employee: null,
    selectionData: {
      userId: null,
      goalSettingId: null,
    },

    release: 0,

    summaryData: {
      overallRating: 0,
      maxScore: 5,
      overallLabel: '',
      insightText: '',
      reviewerRatings: [],
      strongAreas: [],
      selfHigherAreas: [],
      reviewersHigherAreas: [],
      improvementAreas: [],
    },

    feedbackData: [],
  };


  // GET SELECTION FROM URL
  getUrlSelections = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const encoded = params.get('r');

      if (!encoded) {
        return null;
      }

      const decoded = JSON.parse(
        atob(decodeURIComponent(encoded))
      );

      return {
        userId: decoded.u,
        goalSettingId: decoded.g,
      };
    } catch (error) {
      console.error(
        'Error decoding URL parameter',
        error
      );

      return null;
    }
  };


  // GET SELECTION FROM SESSION
  getSessionSelections = () => {
    try {
      const raw = sessionStorage.getItem(
        'team_goals_context'
      );

      if (!raw) { return null; }

      const data = JSON.parse(raw);

      return {
        userId: data.userId || data.selectedEmployeeId,
        goalSettingId: data.goalSettingId || data.selectedGoalCycleId,
      };
    } catch (error) {
      console.error('Error reading sessionStorage', error);
      return null;
    }
  };


  getCookieSelections = () => {
    const selectedEmployeeId = Cookies.get(
      'selectedEmployeeId'
    );

    const selectedGoalCycleId = Cookies.get(
      'selectedGoalCycleId'
    );

    if (
      !selectedEmployeeId ||
      !selectedGoalCycleId
    ) {
      return null;
    }

    return {
      userId: selectedEmployeeId,
      goalSettingId: selectedGoalCycleId,
    };
  };

  getLoggedInUserId = () => {
    return CurrentUserStore?.currentUser?.id || null;
  };

  waitForLoggedInUser = () => {
    return new Promise(resolve => {
      let attempts = 0;
      const maxAttempts = 50;
  
      const checkUser = () => {
        const userId = CurrentUserStore?.currentUser?.id;
  
        if (userId) {
          resolve(userId);
          return;
        }
  
        attempts += 1;
  
        if (attempts >= maxAttempts) {
          console.error(
            "Logged-in user was not available"
          );
          resolve(null);
          return;
        }
  
        setTimeout(checkUser, 100);
      };
  
      checkUser();
    });
  };

  // COMPONENT DID MOUNT

  componentDidMount = async () => {
    try {
      this.setState({
        isInitializing: true,
        isLoading: true,
      });
  
      /*
       * TABLE ROW ACCESS
       * URL contains r
       * ==========================================
       */
      const urlSelection = this.getUrlSelections();
  
      if (
        urlSelection?.userId &&
        urlSelection?.goalSettingId
      ) {
       
  
        this.setState({
          isDirectAccess: false,
          selectionData: urlSelection,
        });
  
        await this.getAllGoalCycleList(
          urlSelection.goalSettingId
        );
  
        await this.fetchReportData(
          urlSelection.userId,
          urlSelection.goalSettingId
        );
  
        return;
      }
  
      /*
       * ==========================================
       * DIRECT EMPLOYEE ACCESS
       * No r in URL
       * ==========================================
       */
  
      const userId = await this.waitForLoggedInUser();
  
      if (!userId) {
        console.error(
          "Unable to find logged-in user"
        );
        return;
      }
  
      /* Get goal cycles */
      const {
        selectedTimeframe,
      } = await this.getAllGoalCycleList();
  
      if (!selectedTimeframe?.id) {
        console.error(
          "No goal cycle found"
        );
        return;
      }
  
      /* Save current selection */
      const selectionData = {
        userId,
        goalSettingId: selectedTimeframe.id,
      };
  
      this.setState({
        isDirectAccess: true,
        selectionData,
        selectedTimeframe,
      });
  
      /*
       * Fetch report
       */
      await this.fetchReportData(
        userId,
        selectedTimeframe.id
      );
  
    } catch (error) {
      console.error(
        "Failed to initialize review report",
        error
      );
    } finally {
      this.setState({
        isInitializing: false,
      });
    }
  };
  // GET GOAL CYCLES

  getAllGoalCycleList = async (selectedGoalSettingId = null) => {
    try {
      const response = await axios.get(
        `${Cookies.get("apiEnv")}/goal_settings/goal_cycle_list`
      );

      const goalCycleList = response.data || [];

      const selectedTimeframe =
        goalCycleList.find(
          cycle => cycle.id === selectedGoalSettingId
        ) || goalCycleList[0] || {};

      this.setState({
        goalCycleList,
        selectedTimeframe,
      });

      return {
        goalCycleList,
        selectedTimeframe,
      };

    } catch (error) {
      console.error(
        "Failed to load goal cycles",
        error
      );

      this.setState({
        goalCycleList: [],
        selectedTimeframe: {},
      });

      throw error;
    }
  };
 

  fetchReportData = async (userId, goalSettingId) => {
    if (!userId || !goalSettingId) {
      return;
    }

    this.setState({
      isLoading: true,
      feedbackData: [],
      release: 0,
    });

    try {
      // First call review API
      const release = await this.fetchReviewReport(
        userId,
        goalSettingId
      );

      // If report is not released, stop here
      if (release !== 1) {
        return;
      }

      // Only released reports should call AI API
      await this.fetchAISummaryReport(
        userId,
        goalSettingId
      );

    } catch (error) {
      console.error( "Failed to fetch report data",error );
    } finally {
      this.setState({isLoading: false,});
    }
  };

  fetchReviewReport = async (userId, goalSettingId) => {
    if (!userId || !goalSettingId) {
      return null;
    }

    try {
      const response = await axios.get(
        `${Cookies.get("apiEnv")}/feedback_reports/employee_form_details`,
        {
          params: {
            goal_setting_id: goalSettingId,
            user_id: userId,
          },
        }
      );

      const apiData =
        response.data?.data ||
        response.data ||
        {};

      const feedbackData =
        apiData.feedback_data || [];

      const release = Number(apiData.release || 0);

      this.setState({
        feedbackData,
        release,
      });

      return release;

    } catch (error) {
      console.error(
        "Failed to fetch review report",
        error
      );

      return null;
    }
  };

  fetchAISummaryReport = async (userId, goalSettingId) => {
    if (!userId || !goalSettingId) {
      return;
    }

    try {
      const response = await axios.get(
        `${Cookies.get('apiEnv')}/feedback_reports/ai_report`,
        {
          params: {
            goal_setting_id: goalSettingId,
            user_id: userId,
          },
        }
      );

      const responseData = response.data?.feedback_ai_report?.response_data || {};
      const userData = response.data?.user;
      const overallSummary = responseData.overall_summary || {};
      const groupBreakdown = responseData.group_breakdown || [];
      const competencyInsights = responseData.competency_insights || {};
      const summaryData = { overallRating: Number( overallSummary.score || 0 ),
      maxScore: Number( overallSummary.max_score || 5 ),
      overallLabel: overallSummary.label || '',
      insightText: overallSummary.insight_text || '',
      reviewerRatings: groupBreakdown.map(
          (item) => ({
            name: item.group,
            rating: Number(item.score || 0),
            type:
              item.group === 'Self'
                ? 'self'
                : 'other',
          })
        ),

        strongAreas: competencyInsights.agreed_strengths || [],
        selfHigherAreas: competencyInsights.self_higher_gaps || [],
        reviewersHigherAreas: competencyInsights.others_higher_gaps || [],
        improvementAreas: competencyInsights.investment_areas || [],
        competency_insights_text: responseData?.competency_insights_text
      };
      this.setState({
        employee: response.data?.feedback_ai_report?.user,
        summaryData,
      });

      return summaryData;
    } catch (error) {
      console.error(
        'Failed to fetch AI summary report',
        error
      );
      userData
      this.setState({
        employee: {
          name:
            apiData?.employee?.name ||
            'John Doe',
        },

        summaryData: {
          overallRating: 0,
          maxScore: 5,
          overallLabel: '',
          insightText: '',
          reviewerRatings: [],
          strongAreas: [],
          selfHigherAreas: [],
          reviewersHigherAreas: [],
          improvementAreas: [],
        },
      });
    }
  };

  handleSelectGoalCycle = async (selectedTimeframe) => {
    const { selectionData } = this.state;
    if (!selectionData?.userId || !selectedTimeframe?.id) {
      return;
    }
    const goalSettingId = selectedTimeframe.id;
    this.setState({
      selectedTimeframe,
      selectionData: {
        ...selectionData,
        goalSettingId,
      },
    });

    await this.fetchReportData(
      selectionData.userId,
      goalSettingId
    );
  };
  handleBack = () => {
    Utilities.navigate("/360_feedback/reports");
  };


  render() {
    const {
      isLoading, isInitializing,
      employee,
      summaryData,
      feedbackData, selectedTimeframe, goalCycleList, release, isDirectAccess
    } = this.state;

    const downloadPDF = () => {
      const element = document.getElementById("summary-report");
      const opt = {
        margin: 10,
        filename: "360Feedback_Report.pdf",
        image: { type: "jpeg", quality: 1 },

        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: false,
          backgroundColor: "#ffffff"
        },
        jsPDF: {
          unit: "mm",
          format: "a3",
          orientation: "portrait"
        },
        pagebreak: { mode: ["css", "legacy"] }
      };

      window.html2pdf().set(opt).from(element).save();
    };


    if(isInitializing || isLoading){
      return (
        <Flexbox  flexGrow={1} width="100hw" alignContent="stretch" className="push-10-l push-10-r" flexDirection="column"
        paddingBottom="0px">
          <Flexbox flexGrow={1} flexDirection="column" justifyContent="center" alignItems="center" >
                  <img style={{ height: "35px", width: "35px" }} src="https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif" alt="Loading..." />
                </Flexbox>
        </Flexbox>
      )
    }

    return (
      <Provider>
        <ThemeWrapper>
          <ErrorBoundary>

            <Flexbox
              flexGrow={1} width="100hw" alignContent="stretch" className="push-10-l push-10-r" flexDirection="column"
              paddingBottom="0px"
            >
              <Flexbox justifyContent="space-between" alignItems="flex-start" className="review-page-header push-20-t push-30-l push-30-r">
                <Flexbox alignItems="">
                { !isDirectAccess &&
                  <div
                    className="review-back-button"
                    onClick={this.handleBack}
                    role="button"
                    tabIndex={0}
                    style={{ marginTop: '10px' }}
                  >
                    ←
                  </div>
                    }
                  <div>
                    <h1 className="review-page-title">
                      Performance Review — {employee?.full_name || employee?.name || "Employee"}
                    </h1>

                    <div className="review-page-description">
                      Review employee performance and feedback.
                    </div>
                  </div>
                </Flexbox>

                <Flexbox alignItems="center">
                  <Tooltip content="Download Report" position={Position.TOP} portalContainer={document.body}>
                    <Icon icon="import" onClick={downloadPDF} className="bp3-text-muted" style={{ cursor: "pointer", marginRight: 10 }} />
                  </Tooltip>

                  <div style={{ width: "220px", padding: "15px" }}>
                    <ScrollableDropdown
                      width={240}
                      label={selectedTimeframe?.title || "Modification cycle"}
                      items={goalCycleList}
                      getKey={item => item.id}
                      getLabel={item => item.title}
                      enableSearch
                      onSelect={this.handleSelectGoalCycle}
                    /> </div>
                </Flexbox>
              </Flexbox>
              <Flexbox flexGrow={1} flexDirection="column" className="fixed-width-container review-360-report" marginTop="20px" >
                {release === 0 ? (
                  <Card className="feedback-not-released">
                    <EmptyStateNotice
                      title={'Review Not Released Yet'}
                      description={'Review will be visible once it is released.'}
                    />

                  </Card>
                ) : (
                  <>
                    <div id="summary-report">
                      <UserBrief360SummaryReport
                        employee={employee}
                        summaryData={summaryData}
                        isLoading={isLoading}
                      />
                      <UserFormBrief360Report
                        feedbackData={feedbackData}
                        isLoading={isLoading}
                      />
                    </div>
                  </>
                )}
              </Flexbox>
            </Flexbox>

          </ErrorBoundary>
        </ThemeWrapper>
      </Provider>
    );
  }
}

